import { createUseStyles } from 'react-jss';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { TextColors } from '@picsart/design-system/foundation/textColors';
import { PrimaryColors } from '@picsart/design-system/foundation/primaryColors';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const GILROY = '"Picsart-Fonts", sans-serif';

const useStyles = createUseStyles(
  {
    page: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      backgroundColor: BackgroundColors.base,
    },
    pageHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s4,
      borderBottom: `1px solid ${BackgroundColors.border}`,
      flexShrink: 0,
    },
    pageTitle: {
      fontFamily: GILROY,
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.semibold,
      color: TextColors.base,
    },
    dropdown: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: 'calc(100% + 6px)',
      right: 0,
      backgroundColor: BackgroundColors.base,
      border: `1px solid ${BackgroundColors.border}`,
      borderRadius: CornerRadius.r12,
      zIndex: 500,
      width: 360,
      maxHeight: 620,
      overflowY: 'auto',
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
    dropdownHeader: {
      padding: `${Spacings.s12} ${Spacings.s16} ${Spacings.s4}`,
    },
    content: {
      flex: 1,
      overflowY: 'auto',
      paddingLeft: Spacings.s8,
    },
    section: {
      padding: `${Spacings.s4} 0`,
    },
    sectionTitle: {
      color: PrimaryColors.base.default,
      padding: `${Spacings.s12} ${Spacings.s12} ${Spacings.s4}`,
      display: 'block',
    },
    menuItem: {
      padding: `${Spacings.s4} ${Spacings.s8}`,
    },
    versionItem: {
      display: 'flex',
      flexDirection: 'column',
      padding: `${Spacings.s8} ${Spacings.s12}`,
      gap: 2,
    },
    versionLabel: {
      fontFamily: GILROY,
      fontSize: FontSizes.s16,
      color: TextColors.base,
    },
    versionValue: {
      fontFamily: GILROY,
      fontSize: FontSizes.s14,
      color: TextColors.tint2,
    },
    actions: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s12,
      padding: `${Spacings.s16} ${Spacings.s16} ${Spacings.s24}`,
      marginTop: 'auto',
      flexShrink: 0,
    },
  },
  { name: 'Settings' }
);

export default useStyles;
